import React from 'react';
import PropTypes from 'prop-types';

const DotLoader = ({ dotCharacter }) => (
    <span className="m2g-dot-loader">
        <span>{dotCharacter}</span>
        <span>{dotCharacter}</span>
        <span>{dotCharacter}</span>
    </span>
);

DotLoader.propTypes = {
    dotCharacter: PropTypes.string,
};

DotLoader.defaultProps = {
    dotCharacter: '.',
};

export default DotLoader;
